"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.waitForRoot = exports.getRoot = exports.registerRoot = void 0;
var Root = null;
var listeners = [];

var registerRoot = function registerRoot(comp) {
  if (!comp) {
    throw new Error("You must pass a React component to registerRoot(), but ".concat(JSON.stringify(comp), " was passed."));
  }

  if (Root) {
    throw new Error('registerRoot() was called more than once.');
  }

  Root = comp;
  listeners.forEach(function (l) {
    l(comp);
  });
};

exports.registerRoot = registerRoot;

var getRoot = function getRoot() {
  return Root;
};

exports.getRoot = getRoot;

var waitForRoot = function waitForRoot(fn) {
  if (Root) {
    fn(Root);
    return function () {
      return undefined;
    };
  }

  listeners.push(fn);
  return function () {
    listeners = listeners.filter(function (l) {
      return l !== fn;
    });
  };
};

exports.waitForRoot = waitForRoot;